import { updateSort } from '!/actions/creators';
import { connect } from 'react-redux';
import Container from '../WidgetContainer/WidgetContainer';

const actions = { updateSort };

const RadioSort = props => {
  const { options, open, title, mobileOnly, name, updateSort } = props;
  
  const onClick = ({ target }) => {
    const { value } = target;
    updateSort(value);
  };

  return (
    <Container {...props}>
      {options.map((option, index) => (
        <label key={index} className="input-radio">
          <input
            type="radio"
            name={name || title}
            value={option.value}
            onClick={onClick}
            defaultChecked={option.default}
          />
          {option.label}
        </label>
      ))}
    </Container>
  );
};

function mapStateToProps({ sorting }) {
  return { options: sorting };
}

export default connect(
  mapStateToProps,
  actions
)(RadioSort);
